export default __webpack_public_path__ + "static/media/github2.93e6871e.png";